var _path, _path2, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreathe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 79.1632C112 52.1865 98.3512 9.23319 82.1748 9.23319C70.866 9.23319 68.0577 22.7426 67.469 35.4367C61.5559 35.2707 61.2515 33.1203 61.2515 29.1414V8.55694C61.2515 6.93473 59.9364 5.61963 58.3142 5.61963H53.6877C52.0655 5.61963 50.7504 6.93473 50.7504 8.55694V29.1414C50.7504 33.1194 50.4462 35.2696 44.535 35.4364C43.9462 22.7424 41.1361 9.23319 29.8288 9.23319C13.6516 9.23319 0.00191239 52.1853 0.00191239 79.156C-0.0043596 80.0072 -0.103816 100.073 5.39134 105.612C6.39307 106.621 7.53457 107.134 8.78628 107.134C12.0934 107.134 13.7376 105.87 16.0143 104.124C18.8707 101.931 22.7809 98.9278 32.7041 96.0671C49.5273 91.2161 47.7792 75.477 45.9263 58.8106C45.4543 54.575 44.9725 50.2278 44.772 45.9342C49.5011 45.7888 53.2762 44.6041 55.9982 42.4039C58.7212 44.6043 62.5027 45.789 67.2325 45.9342C67.0318 50.2276 66.5497 54.5745 66.0791 58.8106C64.2262 75.477 62.4763 91.2161 79.3011 96.0671C89.2227 98.9278 93.1338 101.931 95.9891 104.122C98.2658 105.87 99.9102 107.134 103.217 107.134C104.468 107.134 105.61 106.621 106.611 105.612C112.106 100.073 112.007 80.0079 112 79.1632Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5568_35022",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 113,
    height: 103
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 79.1632C112 52.1865 98.3512 9.23319 82.1748 9.23319C70.866 9.23319 68.0577 22.7426 67.469 35.4367C61.5559 35.2707 61.2515 33.1203 61.2515 29.1414V8.55694C61.2515 6.93473 59.9364 5.61963 58.3142 5.61963H53.6877C52.0655 5.61963 50.7504 6.93473 50.7504 8.55694V29.1414C50.7504 33.1194 50.4462 35.2696 44.535 35.4364C43.9462 22.7424 41.1361 9.23319 29.8288 9.23319C13.6516 9.23319 0.00191239 52.1853 0.00191239 79.156C-0.0043596 80.0072 -0.103816 100.073 5.39134 105.612C6.39307 106.621 7.53457 107.134 8.78628 107.134C12.0934 107.134 13.7376 105.87 16.0143 104.124C18.8707 101.931 22.7809 98.9278 32.7041 96.0671C49.5273 91.2161 47.7792 75.477 45.9263 58.8106C45.4543 54.575 44.9725 50.2278 44.772 45.9342C49.5011 45.7888 53.2762 44.6041 55.9982 42.4039C58.7212 44.6043 62.5027 45.789 67.2325 45.9342C67.0318 50.2276 66.5497 54.5745 66.0791 58.8106C64.2262 75.477 62.4763 91.2161 79.3011 96.0671C89.2227 98.9278 93.1338 101.931 95.9891 104.122C98.2658 105.87 99.9102 107.134 103.217 107.134C104.468 107.134 105.61 106.621 106.611 105.612C112.106 100.073 112.007 80.0079 112 79.1632Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5568_35022)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -26,
    y: -26,
    width: 164,
    height: 164,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5568_35022",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -26,
    y: -26,
    width: 164,
    height: 164
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -26,
    y: -26,
    width: 164,
    height: 164,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5568_35022)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathe);
export default __webpack_public_path__ + "static/media/breathe.e6bd06fd9b51855501c6ab31e9401613.svg";
export { ForwardRef as ReactComponent };